import IMenuItem from '../interfaces/IMenuItem';

const Home: IMenuItem = {
  title: 'Accueil',
  type: 'home',
  url: '',
  img: [],
  more: undefined,
  subMenu: undefined
};

/* SubMenu des cours */
const Courses_Description: IMenuItem = {
  title: 'Description',
  type: 'courses',
  url: 'les-cours#description',
  img: [],
  more: undefined,
  subMenu: undefined
};
const Courses_Horaires: IMenuItem = {
  title: 'Les horaires',
  type: 'courses',
  url: 'les-cours#horaires',
  img: [],
  more: undefined,
  subMenu: []
};
const Courses_Prix: IMenuItem = {
  title: 'Les prix',
  type: 'courses',
  url: 'les-cours#prix',
  img: [],
  more: undefined,
  subMenu: []
};
const Courses_Inscription: IMenuItem = {
  title: 'Inscription',
  type: 'courses',
  url: 'les-cours#inscription',
  img: [],
  more: undefined,
  subMenu: []
};
const Courses_Ecoles: IMenuItem = {
  title: 'Pour les écoles',
  type: 'courses',
  url: 'les-cours#ecoles',
  img: [],
  more: undefined,
  subMenu: []
};

/* Cours */

const Courses: IMenuItem = {
  title: 'Les cours',
  type: 'courses',
  url: 'les-cours',
  img: [],
  more: undefined,
  subMenu: undefined//[Courses_Description, Courses_Horaires, Courses_Prix, Courses_Inscription, Courses_Ecoles]
};
const Stages: IMenuItem = {
  title: 'Stages & Weekends',
  type: 'stages',
  url: 'stages-week-ends',
  img: [],
  more: undefined,
  subMenu: undefined
};
const Photos: IMenuItem = {
  title: 'Photos',
  type: 'photos',
  url: 'photos',
  img: [],
  more: undefined,
  subMenu: undefined
};
const Birthday: IMenuItem = {
  title: 'Anniversaire',
  type: 'event',
  url: 'anniversaire',
  img: [],
  more: undefined,
  subMenu: undefined
};
const Location: IMenuItem = {
  title: 'Location',
  type: 'Location',
  url: 'location',
  img: [],
  more: undefined,
  subMenu: undefined
};
const Infos_Historique: IMenuItem = {
  title: "L'historique",
  type: 'histo',
  url: 'infos#histo',
  img: [],
  more: undefined,
  subMenu: undefined
};
const Infos_Philo: IMenuItem = {
  title: 'La philosophie',
  type: 'philo',
  url: 'info#philo',
  img: [],
  more: undefined,
  subMenu: undefined
};
const Infos_Team: IMenuItem = {
  title: "L'équipe",
  type: 'team',
  url: 'infos#team',
  img: [],
  more: undefined,
  subMenu: undefined
};
const Infos: IMenuItem = {
  title: 'Infos',
  type: 'infos',
  url: 'infos',
  img: [],
  more: undefined,
  subMenu: undefined//[Infos_Historique, Infos_Philo, Infos_Team]
};
const Animations: IMenuItem = {
  title: 'Animations',
  type: 'Animations',
  url: 'animations',
  img: [],
  more: undefined,
  subMenu: undefined
};
// const Blog : ILink = {
//   title: 'Blog',
//   type: 'blog',
//   url: 'blog',
//   img: [],
//   more: undefined,
//   subMenu : []
// };
const Links: IMenuItem[] = [
  Home,
  Courses,
  Stages,
  Photos,
  Animations,
  Location,
  Birthday,
  Infos,
  //  Blog,
];

export default Links;
